module.exports = __webpack_public_path__ + "media/images/signature-8deb84398b0f5e94c2d121eb1c4ad001.png";